/* istanbul ignore file */
import { useCrudService } from 'framework/crud';
import { useKernelApi } from 'infrastructure/api';

export type AccountLitigationHoldDto = {
  id: string;
  isOnLitigationHold: boolean | null;
  litigationHoldReason: string | null;
};

const useAccountResourceService = () => {
  const baseCrudRequests = useCrudService({
    singleResourceUrl: '/crm/accounts/:id',
    listResourceUrl: '/crm/accounts',
    useService: useKernelApi,
  });

  return {
    ...baseCrudRequests,
  };
};

export default useAccountResourceService;
